import { render, staticRenderFns } from "./Flat.vue?vue&type=template&id=adc33bb4&"
import script from "./Flat.vue?vue&type=script&lang=js&"
export * from "./Flat.vue?vue&type=script&lang=js&"
import style0 from "./Flat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports